import { styled, motion, Image, colors } from '../../styles/base/_allBase.styles'

export const BottomFooterDiv = styled.footer`
  width:100%; padding:clamp(4.8rem,7vw,8rem) max(2rem,6vw) 2.4rem;
  background:${colors.warmPalette.primaryDark}; color:${colors.neutralPalette.white};
  border-top:4px solid ${colors.brandPalette.brass};
`
export const FlexRow = styled.div`
  width:min(120rem,100%); margin:0 auto; display:grid; grid-template-columns:1.25fr repeat(4,1fr); gap:clamp(2.4rem,4vw,6rem);
  &:last-of-type{display:flex;align-items:center;gap:2rem;border-top:1px solid rgba(255,255,255,.18);padding-top:2.4rem;}
  @media(max-width:899px){grid-template-columns:repeat(2,1fr); &:last-of-type{display:flex;flex-wrap:wrap;}}
  @media(max-width:479px){grid-template-columns:1fr; gap:2.8rem; &:last-of-type{display:flex;flex-direction:column;align-items:flex-start;}}
`
export const FlexColumn = styled.div`
  display:flex; flex-direction:column; align-items:flex-start; gap:.85rem; min-width:0;
  > p:first-child{font-size:1.2rem;font-weight:700;text-transform:uppercase;letter-spacing:.12em;color:${colors.warmPalette.secondContrast};margin:0 0 .7rem;}
  a p{margin:0;color:white!important;font-size:1.45rem;line-height:1.45;}
  a:hover p{text-decoration:underline;text-underline-offset:.35rem;}
`
export const StyleP = styled.p`margin:0;color:inherit;font-size:1.4rem;`
export const SocialContainer = styled.div`display:flex;align-items:center;gap:1rem;`
export const LogoContainer = styled.div`width:3.8rem;height:3.8rem;display:grid;place-items:center;border:1px solid rgba(255,255,255,.35);border-radius:50%;background:white; svg{width:2rem;height:2rem;}`
export const LogoWrapper = styled.div`display:flex;align-items:center;`
export const ImgFullLogo = styled(motion(Image))`width:min(22rem,100%);height:auto;display:block;`
